const getEncryptedPayload = (payload) => {
  const d = new Date();
  const issueTimeNow = d.getTime();
  const expiry = (d.getTime() + 1000 * 60 * 10);
  const jwtIDRan = Math.floor((1 + Math.random()) * 0x10000).toString(16).substring(1);
  return {
    iss: 'https://openid.net',
    sub: 'alice',
    aud: ['https://app-one.com', 'https://app-two.com'],
    exp: expiry,
    iat: issueTimeNow,
    nbf: issueTimeNow,
    jti: jwtIDRan,
    ...payload
  }
}

export default getEncryptedPayload;